(function () {
  'use strict';

  function initCarousel(section) {
    var wrapper = section.querySelector('.carousel-marquee__wrapper');
    var track = section.querySelector('.carousel-marquee__track');
    if (!wrapper || !track) return;

    var speed = parseFloat(section.dataset.speed) || 60; // px per second
    var pauseOnHover = section.dataset.pauseOnHover === 'true';
    var pauseOnClick = section.dataset.pauseOnClick === 'true';
    var animateOnlyWhenVisible = section.dataset.animateOnlyWhenVisible === 'true';
    var manuallyPaused = false;
    var isOffscreen = false;

    function setDuration() {
      // Track contains two identical sets back to back; measure one set's width.
      var fullWidth = track.scrollWidth / 2;
      if (fullWidth <= 0) return;
      var duration = fullWidth / speed;
      track.style.setProperty('--duration', duration + 's');
    }

    var isHovering = false;

    function updatePausedState() {
      var shouldPause = manuallyPaused || isHovering || isOffscreen || isDragging;
      section.classList.toggle('carousel-marquee--paused', shouldPause);
    }

    setDuration();

    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(function () {
        setDuration();
      });
      resizeObserver.observe(track);
    } else {
      window.addEventListener('resize', setDuration);
    }

    if (pauseOnHover) {
      wrapper.addEventListener('mouseenter', function () {
        isHovering = true;
        updatePausedState();
      });
      wrapper.addEventListener('mouseleave', function () {
        isHovering = false;
        updatePausedState();
      });
    }

    if (pauseOnClick) {
      wrapper.addEventListener('click', function (event) {
        // Don't hijack clicks on links inside the carousel
        if (event.target.closest('a')) return;
        manuallyPaused = !manuallyPaused;
        updatePausedState();
      });
    }

    // Only animate while the section is scrolled into view
    if (animateOnlyWhenVisible && 'IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            isOffscreen = !entry.isIntersecting;
            updatePausedState();
          });
        },
        { threshold: 0 }
      );
      visibilityObserver.observe(section);
    }

    // Basic touch/drag scrub support (pauses the animation while dragging)
    var isDragging = false;
    var startX = 0;
    var startScrollLeft = 0;

    wrapper.addEventListener(
      'touchstart',
      function (e) {
        isDragging = true;
        startX = e.touches[0].clientX;
        startScrollLeft = wrapper.scrollLeft;
        updatePausedState();
      },
      { passive: true }
    );

    wrapper.addEventListener(
      'touchmove',
      function (e) {
        if (!isDragging) return;
        var diff = startX - e.touches[0].clientX;
        wrapper.scrollLeft = startScrollLeft + diff;
      },
      { passive: true }
    );

    wrapper.addEventListener('touchend', function () {
      isDragging = false;
      updatePausedState();
    });
  }

  function init() {
    document.querySelectorAll('.carousel-marquee').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when a new instance of this section is added/edited in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.carousel-marquee');
    if (section) initCarousel(section);
  });
})();